import React from "react";

const Kotlin_Quiz = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Quiz</h1>
      <p>Content for Kotlin Quiz goes here.</p>
    </div>
  );
};

export default Kotlin_Quiz;
